module.exports = __webpack_public_path__ + "media/images/samples/300x300/8-31174cd07dfc7bc5fb33dda865393098.jpg";